<template>
  <div class="form p-12">
    <!-- 第一部分 -->
    <div class="f-500 flex items-center grid grid-cols-2 gap-8">
      <div flex class="flex items-center">
        <div class="mr-4 "> <span style="color:red">*</span>Type:</div>
        <el-select v-model="dataForm.Type" :disabled="disabled || isPsaUnberth" size="small">
          <el-option label="Discharging" value="Discharging"></el-option>
          <el-option label="Loading" value="Loading"></el-option>
          <el-option label="Ballast" value="Ballast"></el-option>
          <el-option label="Bunkering" value="Bunkering"></el-option>
        </el-select>
      </div>
      <div class="flex items-center" v-if="isForPilot && isLoadingMaster">
        <div class="mr-4 "> <span style="color:red">*</span>PSA:</div>
        <el-checkbox v-model="psaUiOpen" :disabled="psaCheckboxDisabled" @change="onPsaChange" />
        <i v-if="psaUpdating" class="el-icon-loading ml-2"></i>
      </div>
      <div class="flex items-center" v-if="canActUnberth || canViewUnberth">
        <el-checkbox v-model="unberthWithoutOperationChecked" :disabled="canViewUnberth"
          @change="onUnberthWithoutOperationChange"></el-checkbox>
        <span class="ml-2 unberth-label"
          :class="{ 'unberth-remark-link': canViewUnberth && nominationData.unberthWithoutOperation == 1 }"
          @click="onUnberthLabelClick">Unberth Without Operation</span>
      </div>
    </div>

    <!-- 表格 -->
    <el-table :data="dataForm.list" class="mt-4">
      <el-table-column label="Loading" prop="formDescription" width="600">
        <template slot-scope="scope">
          <span v-if="checkNotRequired(scope.row.formDescription, scope.$index)" style="padding-left:9px;"></span>
          <span v-else style="color:red">*</span>
          {{ scope.row.formDescription }}
        </template>
      </el-table-column>
      <el-table-column label="Date and Time" min-width="300">
        <template slot-scope="scope">
          <div class="flex">
            <div :class="{ 'time-error': !!timeErrors[scope.$index] }">
              <el-date-picker v-model="scope.row.getTime" :disabled="disabled || checkDisabled(scope.$index)"
                class="mr-4" prefix-icon="el-icon-date" size="mini" type="datetime" :editable="false"
                value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss" />
            </div>
            <el-button size="mini" @click="fillCurrentTime(scope.row)"
              :disabled="disabled || checkDisabled(scope.$index)">
              Now
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="f-600 black mt-4 flex justify-between">
      <div style="height: 30px;">
        <el-button size="small" type="primary" @click="add" :disabled="disabled">Add</el-button>
      </div>
    </div>
    <el-table :data="dataForm.listItem" class="mt-4">
      <el-table-column label="Cause of Delay" min-width="500">
        <template slot-scope="scope">
          <el-input v-model="scope.row.causeOfDelay" :disabled="disabled" size="mini"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="Date and Time(From)" min-width="250">
        <template slot-scope="scope">
          <el-date-picker v-model="scope.row.fromTime" :disabled="disabled" :editable="false" prefix-icon="el-icon-date"
            size="mini" type="datetime"></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column label="Date and Time(To)" min-width="250">
        <template slot-scope="scope">
          <el-date-picker v-model="scope.row.toTime" :disabled="disabled" :editable="false" prefix-icon="el-icon-date"
            size="mini" type="datetime"></el-date-picker>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <i v-if="dataForm.listItem.length > 1 && !disabled" class="el-icon-circle-close cursor-pointer fs-15"
            style="color: red" @click="delCause(scope.$index)"></i>
        </template>
      </el-table-column>
    </el-table>
    <!--
    <div style="color: red;" class="mt-4 mb-4 fs-12">
      *Please fill in at least 1 product and its qualities.
    </div>
    -->
    <!-- REMARKS FIELD -->
    <div class="flex mt-6">
      <span style="font-size: 12px" class="f-600">Remarks:</span>
      <el-input v-model="dataForm.remarks" :maxlength="600" :rows="3" class="ml-1" show-word-limit type="textarea"
        :disabled="!canEditRemarks"></el-input>
    </div>

    <div class="mt-8 f-600" style="color:#4C565C ">
      Signature
    </div>
    <div class="flex flex-wrap w-full xl:w-1/2 mt-4 justify-between">
      <div class="w-full sm:w-1/2 ">
        <div class="f-600">Terminal Representative</div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Name:</span>
          <span class="ml-2">{{ sign.terminal.name }}</span>
        </div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Date and Time:</span>
          <span class="ml-2">{{ sign.terminal.createTime }}</span>
        </div>
        <div class="mt-4 f-600 flex" style="font-size: 12px">
          <span>Signature:</span>
          <img v-if="sign.terminal.eSignature" :src="sign.terminal.eSignature" class="ml-2" style="width: 100px;" />
        </div>
      </div>
      <div class="w-full mt-4 sm:w-1/2 sm:mt-0">
        <div class="f-600">Barge Representative</div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Name:</span>
          <span class="ml-2">{{ sign.barge.name }}</span>
        </div>
        <div class="mt-4 f-600" style="font-size: 12px">
          <span>Date and Time:</span>
          <span class="ml-2">{{ sign.barge.createTime }}</span>
        </div>
        <div class="mt-4 f-600 flex" style="font-size: 12px">
          <span>Signature:</span>
          <img v-if="sign.barge.eSignature" :src="sign.barge.eSignature" class="ml-2" style="width: 100px;" />
        </div>
      </div>
    </div>
    <el-dialog title="PSA Remark" :visible.sync="psaRemarkDialogVisible" :close-on-click-modal="false" width="500px"
      @close="onPsaDialogClose">
      <div style="color:#606266; font-size: 13px; margin-bottom: 8px;">
        Remark
      </div>

      <el-input v-model="psaRemarkDraft" type="textarea" :rows="4" />

      <template #footer>
        <el-button size="mini" @click="cancelPsaRemark">Cancel</el-button>
        <el-button size="mini" type="primary" @click="confirmPsaRemark">Confirm</el-button>
      </template>
    </el-dialog>

    <el-dialog title="Unberth Without Operation" :visible.sync="unberthDialogVisible" :close-on-click-modal="false"
      width="480px" @close="onUnberthDialogClose" custom-class="unberth-dialog">
      <el-alert type="warning" show-icon :closable="false" style="margin-bottom: 20px;"
        title="This action cannot be reverted once submitted." />
      <el-form label-position="top" size="small" @submit.native.prevent>
        <el-form-item class="mb-0">
          <template #label>
            <span v-if="!unberthViewMode" style="color:#f56c6c">*</span>Remark
          </template>
          <el-input v-model="unberthRemark" type="textarea" :disabled="unberthViewMode"
            :rows="unberthViewMode ? 12 : 4"
            :resize="unberthViewMode ? 'none' : 'vertical'"
            :maxlength="unberthViewMode ? undefined : 1000" :show-word-limit="!unberthViewMode"
            placeholder="Please state the reason for unberthing without operation" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button size="small" @click="onUnberthDialogClose">{{ unberthViewMode ? 'Close' : 'Cancel' }}</el-button>
        <el-button v-if="!unberthViewMode" size="small" type="primary" :loading="unberthSubmitting"
          @click="submitUnberthWithoutOperation">Submit</el-button>
      </template>
    </el-dialog>

  </div>
</template>
<script>
import { saveOrUpdateForms, selectFromById, updateTimeSheetPermission } from "@/services/form";
import { unberthWithoutOperation } from "@/services";
import dayjs from "dayjs";
import { mapState } from "vuex";

export default {
  name: "TimeSheet",
  props: {
    disabled: {
      type: Boolean
    },
    sign: {
      type: Object
    },
    beforeAfterFlag: {
      type: Number,
      default: 1,
    },
    nominationData: {
      type: Object
    },
    modifyReason: {
      type: String,
    }
  },
  data() {
    return {
      dataForm: {
        remarks: "",
        list: [],
        listItem: []
      },
      params: {},
      beforeLength: 9,
      timeErrors: {},
      psaUiOpen: false,
      psaData: {
        open: false,
        remark: ""
      },
      psaRemarkDialogVisible: false,
      psaRemarkDraft: "",
      psaPreviousOpen: false,
      psaUpdating: false,
      unberthWithoutOperationChecked: false,
      unberthDialogVisible: false,
      unberthViewMode: false,
      unberthRemark: "",
      unberthSubmitting: false,
    }
  },
  async mounted() {
    if (this.$route.query) {
      this.params = this.$route.query
      await this.getDetail()
    }
  },
  watch: {
    nominationData: {
      immediate: true,
      deep: true,
      handler(n) {
        if (!n) return;

        this.unberthWithoutOperationChecked = n.unberthWithoutOperation == 1;

        if (n.pilotTypeOpen !== undefined && n.pilotTypeOpen !== null) {
          const open = !!n.pilotTypeOpen;
          this.psaData.open = open;
          this.psaUiOpen = open;
        }

        if (n.pilotTypeRemark !== undefined && n.pilotTypeRemark !== null) {
          this.psaData.remark = n.pilotTypeRemark || "";
        }
      }
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    isForPilot() {
      return this.nominationData.typeOfPilot == 'IHP'
    },
    isPsaUnberth() {
      return !!(this.nominationData
        && this.nominationData.typeOfPilot === 'PSA'
        && this.nominationData.unberthWithoutOperation == 1);
    },
    canEditRemarks() {
      return this.$store.state.userInfo.role == 1 && this.nominationData?.status === 4;;
    },
    isLoadingMaster() {
      return this.userInfo.userType == 1 && this.userInfo.role == 11;
    },
    psaCheckboxDisabled() {
      if (!this.isLoadingMaster) return true;
      if (this.disabled) return true;
      if (this.psaUpdating) return true;
      return false;
    },
    isBargeRep() {
      return this.userInfo.userType == 4 && this.userInfo.role == 8;
    },
    isLeader() {
      return this.userInfo.userType == 1 && this.userInfo.role == 3
    },
    // logistics only; actionable from booked (status 2 with loading started) through signing in progress
    // (status 3), and only while not already marked
    canActUnberth() {
      const n = this.nominationData;
      if (!n) return false;
      const booked = n.status === 2 && n.loadingType !== null && n.loadingType !== undefined;
      const signingInProgress = n.status === 3;
      return this.userInfo.role == 1 && (booked || signingInProgress) && n.unberthWithoutOperation != 1;
    },
    // logistics can still view the (disabled) checkbox once it is marked, or on any completed nom
    canViewUnberth() {
      const n = this.nominationData;
      if (!n) return false;
      const marked = n.unberthWithoutOperation == 1;
      const completed = n.status === 4;
      return this.userInfo.role == 1 && (marked || completed);
    },
  },
  methods: {
    onUnberthWithoutOperationChange(checked) {
      if (checked) {
        this.unberthViewMode = false;
        this.unberthRemark = "";
        this.unberthDialogVisible = true;
      }
    },
    onUnberthLabelClick() {
      if (this.canViewUnberth && this.nominationData && this.nominationData.unberthWithoutOperation == 1) {
        // marked nom -> open the remark (read-only)
        this.openUnberthView();
      } else if (this.canActUnberth) {
        // actionable -> behave like ticking the checkbox
        this.unberthWithoutOperationChecked = true;
        this.onUnberthWithoutOperationChange(true);
      }
    },
    openUnberthView() {
      this.unberthViewMode = true;
      this.unberthRemark = this.nominationData ? (this.nominationData.unberthWithoutOperationRemark || "") : "";
      this.unberthDialogVisible = true;
    },
    onUnberthDialogClose() {
      this.unberthDialogVisible = false;
      this.unberthViewMode = false;
      // keep it checked if the nom is already marked (view mode); otherwise revert the cancelled tick
      this.unberthWithoutOperationChecked = !!(this.nominationData && this.nominationData.unberthWithoutOperation == 1);
      this.unberthRemark = "";
    },
    submitUnberthWithoutOperation() {
      if (!this.unberthRemark || !this.unberthRemark.trim()) {
        this.$message.error("Remark is required");
        return;
      }
      this.unberthSubmitting = true;
      unberthWithoutOperation(this.params.id, this.unberthRemark.trim())
        .then(() => {
          this.$message.success("Unberth Without Operation applied");
          this.unberthDialogVisible = false;
          this.unberthWithoutOperationChecked = true;
          this.unberthRemark = "";
          this.$emit("update");
        })
        .finally(() => {
          this.unberthSubmitting = false;
        });
    },
    delCause(index) {
      this.dataForm.listItem.splice(index, 1)
    },
    save() {
      if (!this.validateSequence()) return
      const data = {
        ...this.dataForm,
        nominationId: this.params.id,
        list: this.dataForm.list.map(item => {
          return {
            ...item,
            nominationId: this.params.id,
          }
        }),
        listItem: this.dataForm.listItem.map(item => {
          return {
            ...item,
            nominationId: this.params.id,
          }
        }),
        beforeAfterFlag: this.beforeAfterFlag,
        reasonToModifyTimesheet: this.modifyReason
      }

      saveOrUpdateForms(data).then(res => {
        this.getDetail()
        this.$emit('update')
        this.$message.success('Save Success')
      }).catch(() => {
        this.$emit('update')
      })
    },
    add() {
      this.dataForm.listItem.push({})
    },
    fillCurrentTime(row) {
      // console.log(row)
      row.getTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss')
    },
    async getDetail() {
      const res = await selectFromById({ nId: this.params.id, fId: 18 })

      const list = (res.data.list || []).map((row, idx) => ({
        ...row,
        getTime: this.normalizeToString(row.getTime),
        beforeAfterFlag: idx < this.beforeLength ? 0 : 1
      }))

      const listItem = (res.data.listItem && res.data.listItem.length > 0)
        ? res.data.listItem
        : [{}]

      const listItemFixed = listItem.map(x => ({
        ...x,
        fromTime: this.normalizeToDate(x.fromTime),
        toTime: this.normalizeToDate(x.toTime),
      }))

      this.dataForm = {
        ...res.data,
        remarks: res.data.remarks || "",
        list,
        listItem: listItemFixed,
      };
      this.psaData.open = !!(res.data.psaOpen ?? this.nominationData?.pilotTypeOpen ?? false);
      this.psaData.remark = (res.data.pilotTypeRemark ?? this.nominationData?.pilotTypeRemark ?? "") || "";

      this.psaUiOpen = this.psaData.open;

    },
    filterOutFirst3Last3(index) {
      return this.isForPilot ? index >= 3 && index < (this.dataForm.list.length - 3) : true
    },
    checkDisabled(index) {
      if (this.disabled) return true;

      const total = this.dataForm.list.length;
      const first3 = index < 3;
      const last3 = index >= total - 3;

      const type = this.nominationData?.typeOfPilot;
      const isIhpNomination = type === "IHP";
      const isPsaNomination = type === "PSA";

      // tab split
      const inBeforeSection = index < this.beforeLength;
      const inAfterSection = index >= this.beforeLength;

      const isOnBeforeTab = this.beforeAfterFlag == 0;
      const isOnAfterTab = this.beforeAfterFlag == 1;

      const inCurrentTab =
        (isOnBeforeTab && inBeforeSection) ||
        (isOnAfterTab && inAfterSection);

      if (!inCurrentTab) return true;

      if (isPsaNomination) {
        // PSA Unberth Without Operation: Logistics may fill ONLY the first three (before tab) and
        // last three (after tab) pilot timings; every other row stays disabled.
        const isUnberth = this.nominationData?.unberthWithoutOperation == 1;
        const isLogistics = this.userInfo.role == 1;
        if (isUnberth && isLogistics) return !(first3 || last3);
        if (this.isLoadingMaster || this.isBargeRep || this.isLeader) return false;
        return true;
      }
      if (isIhpNomination) {
        const isPilotOnlyRow = first3 || last3;
        if (this.isLoadingMaster && this.psaData.open) {
          return false;
        }
        if (isPilotOnlyRow) return true;
        if (this.isLoadingMaster || this.isBargeRep || this.isLeader) return false;

        return true;
      }
      return true;
    },
    checkNotRequired(description, index) {
      // PSA Unberth Without Operation: the pilot timings are filled by Loading Master / Logistics —
      // first three on the before-loading tab, last three on the after-loading tab. Show the red *
      // on those fields on the relevant tab; everything else is optional. This takes precedence over
      // the general notRequired list below (some of the last-three unberthing timings appear there).
      if (this.nominationData && this.nominationData.unberthWithoutOperation == 1
        && this.nominationData.typeOfPilot === 'PSA') {
        const total = this.dataForm.list.length
        if (this.beforeAfterFlag == 0) return !(index < 3)          // before tab: first three
        return !(index >= total - 3)                                // after tab: last three
      }
      const notRequired = [
        'Notice of readiness tendered',
        'Notice of readiness accepted',
        'Pilot on board for sailing',
        'Started unmooring',
        'Vessel all clear',
      ]
      if (notRequired.includes(description)) return true
      return false
    },

    normalizeToString(v) {
      if (!v) return null
      const d = dayjs(typeof v === 'string' ? v.replace('T', ' ') : v)
      return d.isValid() ? d.format('YYYY-MM-DD HH:mm:ss') : null
    },

    normalizeToDate(v) {
      if (!v) return null
      const d = dayjs(typeof v === 'string' ? v.replace('T', ' ') : v)
      return d.isValid() ? d.toDate() : null
    },

    validateSequence() {
      this.timeErrors = {}

      const list = this.dataForm?.list || []
      if (!list.length) return true
      if (this.disabled) return true

      const timed = []
      for (let i = 0; i < list.length; i++) {
        const raw = list[i]?.getTime
        if (!raw) continue

        const t = dayjs(raw)
        if (!t.isValid()) continue

        timed.push({ i, t })
      }

      for (let k = 1; k < timed.length; k++) {
        const prev = timed[k - 1]
        const cur = timed[k]

        if (cur.t.isBefore(prev.t)) {
          const prevDisabled = this.checkDisabled(prev.i)
          const curDisabled = this.checkDisabled(cur.i)

          let highlightIndex = cur.i
          if (curDisabled && !prevDisabled) highlightIndex = prev.i
          else if (!curDisabled) highlightIndex = cur.i
          else highlightIndex = cur.i

          this.$set(this.timeErrors, highlightIndex, true)

          this.$message.error(
            `The datetime for ${list[cur.i]?.formDescription} cannot be earlier than ${list[prev.i]?.formDescription}`
          )
          return false
        }
      }

      return true
    },

    async onPsaChange(val) {
      if (val === true) {
        this.psaRemarkDraft = this.psaData.remark || "";
        this.psaRemarkDialogVisible = true;
        return;
      }

      try {
        this.psaUpdating = true;

        await updateTimeSheetPermission({
          nominationId: Number(this.params.id),
          open: false,
          remark: ""
        });

        this.psaData.open = false;
        this.psaData.remark = "";
        this.psaUiOpen = false;

        await this.getDetail();
        this.$emit("update");

      } catch (e) {
        this.psaUiOpen = true;
      } finally {
        this.psaUpdating = false;   // ✅ stop loading
      }
    },

    async confirmPsaRemark() {
      const remark = (this.psaRemarkDraft || "").trim();
      if (!remark) return this.$message.error("Remark is required.");

      try {
        this.psaUpdating = true;

        await updateTimeSheetPermission({
          nominationId: Number(this.params.id),
          open: true,
          remark
        });

        this.psaData.open = true;
        this.psaData.remark = remark;
        this.psaUiOpen = true;

        this.psaRemarkDialogVisible = false;

        await this.getDetail();
        this.$emit("update");

      } catch (e) {
        this.psaUiOpen = false;
      } finally {
        this.psaUpdating = false;
      }
    },

    cancelPsaRemark() {
      // ✅ user cancelled, revert checkbox back to committed state
      this.psaRemarkDialogVisible = false;
      this.psaUiOpen = this.psaData.open;
    },

    onPsaDialogClose() {
      if (this.psaData.open && !(this.psaData.remark || "").trim()) {
        this.psaData.open = false;
      }
    },

  },
}
</script>


<style scoped lang="scss">
.form {
  font-size: 15px;
  color: #82889C;
  background-color: #fff;
}

::v-deep .time-error .el-input__inner {
  border-color: #F56C6C !important;
}

::v-deep .time-error .el-input__inner:focus {
  border-color: #F56C6C !important;
}

.unberth-label {
  color: #606266;
}

.unberth-remark-link {
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: #409EFF;
  }
}

::v-deep .unberth-dialog {
  border-radius: 8px;

  .el-dialog__header {
    padding: 18px 22px 10px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 12px 22px 4px;
  }

  .el-dialog__footer {
    padding: 12px 22px 18px;
  }

  .el-form-item__label {
    padding-bottom: 4px;
    line-height: 1.2;
  }
}
</style>
